import React, { PureComponent } from 'react';
import classnames from 'classnames';

import routes from '../../../utils/routeTranslator';

import './L4PopularCategories.scss';

type TPopularCategory = {
  id: string;
  slug: string;
  name: string;
};

type L4PopularCategories$Props = {
  categories: TPopularCategory[];
  city: string;
  oneColumn?: boolean;
  citySlug?: string;
  isNeighbourhoods?: boolean;
  neighbourhoodSlug?: string;
};

class L4PopularCategories extends PureComponent<L4PopularCategories$Props> {
  render() {
    const { categories, city, oneColumn, isNeighbourhoods, neighbourhoodSlug } = this.props;
    const popularCategoriesCN = classnames({
      'l4PopularCategories': true,
      'l4PopularCategories_oneColumn': oneColumn,
    });

    return (
      <ul className={popularCategoriesCN}>
        {categories.map((category) => (
          <li className="l4PopularCategories__item" key={`l4PopularCategories_${category.slug}`}>
            <a
              className="l4PopularCategories__link"
              href={
                isNeighbourhoods
                  ? routes.get('front::category_city', {
                      slug: category.slug,
                      city,
                      neighbourhood: neighbourhoodSlug,
                    })
                  : routes.get('front::category', { slug: category.slug, city })
              }
            >
              {category.name}
            </a>
          </li>
        ))}
      </ul>
    );
  }
}

export default L4PopularCategories;
